export const home = {
  nav: {
    ariaPrimary: "Navegação principal",
    cta: "Falar com a mesa",
    ghost: "Entrar",
    links: {
      product: "Produto",
      api: "API",
      security: "Segurança",
      pricing: "Preços",
      faq: "FAQ",
      contact: "Contato",
    },
  },
  hero: {
    tag: "Multi-rede · Liquidação 24/7",
    titleLine1: "Cobre em qualquer moeda.",
    titleLine2Prefix: "Receba",
    titleLine2Highlight: "na sua.",
    description:
      "Fiat, stablecoin e cripto em um único fluxo. Liquidez própria para entrega imediata. Operação institucional embutida.",
    cta: "Falar com a mesa",
    ctaSecondary: "Ver a API",
    imageAlt: "Operação multiativo e liquidação cross-currency",
    trustLabel: "Construído para operar com",
    flow: {
      label: "Exemplo de fluxo",
      status: "Liquidação em segundos",
    },
  },
  trustMarquee: {
    eyebrow: "Cobertura",
    title: "Moedas e trilhos suportados",
    description:
      "Um conjunto curado de ativos fiat, stablecoins e cripto — em todas as redes principais.",
    assetLabels: {
      USD: "Dólar americano",
      BRL: "Real brasileiro",
      EUR: "Euro",
      MXN: "Peso mexicano",
      USDT: "Tether",
      USDC: "USD Coin",
      DAI: "Dai",
      BTC: "Bitcoin",
      ETH: "Ethereum",
    },
  },
  howItWorks: {
    eyebrow: "Fluxo",
    title: "Três passos. Um trilho.",
    description:
      "Siga um pagamento real: cobrança em USD, cliente paga em cripto, você recebe em BRL — tudo dentro do mesmo trilho.",
    steps: {
      "01": {
        kicker: "Emissão",
        title: "Você cobra em qualquer moeda",
        subtitle: "Em menos de um minuto você cria a fatura e envia o link.",
        description:
          "Defina em qual moeda quer cobrar e em qual quer receber. A mesa mostra ao cliente todas as formas de pagamento disponíveis.",
        meta: "Painel · API · SDK",
        effect: "Fatura criada e pronta para receber.",
        artifactLabel: "POST /v1/invoices",
        artifactKeys: {
          charge: "charge",
          receive: "receive",
          payment_options: "payment_options",
        },
      },
      "02": {
        kicker: "Pagamento",
        title: "Seu cliente paga como prefere",
        subtitle: "Fiat, stablecoin ou cripto — em qualquer rede suportada.",
        description:
          "A validação de rede, câmbio e compliance é nossa. Seu cliente só escolhe o meio mais conveniente.",
        meta: "Multiativo · Multi-rede",
        effect: "Pagamento confirmado. Rede e câmbio validados.",
        fromNote: "Cliente enviou",
        toNote: "Detectado e validado",
        toRail: "equivalente",
      },
      "03": {
        kicker: "Liquidação",
        title: "Você recebe na sua moeda, na hora",
        subtitle: "Liquidez própria fecha o ciclo em segundos.",
        description:
          "Sem esperar janela bancária nem confirmação de terceiros. Webhook assinado dispara sua conciliação automática.",
        meta: "Liquidação instantânea",
        effect: "Valor creditado. Conciliação automática disparada.",
      },
    },
  },
  differentials: {
    kicker: "Por que a mesa",
    title: "O que faz a mesa ser a mesa.",
    description:
      "Quatro camadas de infraestrutura construídas para quem cobra e recebe em escala — não para quem experimenta.",
    hero: {
      title: "Liquidez própria",
      subtitle: "O dinheiro chega agora, não amanhã.",
      description:
        "Entrega imediata sem depender de janela bancária, confirmação de terceiros ou liquidez externa. Fundos próprios fecham o ciclo em segundos.",
      metric: {
        value: "~18s",
        label: "tempo médio de liquidação",
      },
    },
    items: {
      multiativo: {
        title: "Multiativo nativo",
        description:
          "Fiat, stablecoin e cripto em um único fluxo. Não é crypto-only nem fiat-only — é um trilho só.",
        proof: "3 classes · 1 trilho",
      },
      multiRede: {
        title: "Multi-rede com validação",
        description:
          "Validação cross-rede automática. Nunca envia para endereço ou rede errada.",
        proof: "Zero erros de rede",
      },
      institucional: {
        title: "Operação institucional",
        description:
          "Compliance, ledger auditável e segregação de ambientes embutidos. Seus controles, nosso trabalho.",
        proof: "KYC · AML · BACEN",
      },
    },
  },
  useCases: {
    kicker: "Para quem é a mesa",
    title: "Reconhece sua operação aqui?",
    description:
      "Quatro perfis, um trilho. A mesa se adapta à sua dor — não o contrário.",
    cta: "Falar com a mesa",
    cases: {
      exportadora: {
        label: "Exportadora",
        painCta: "Cobra em USD, recebe em BRL",
        headline: "Venda no exterior, receita no Brasil.",
        description:
          "Emita faturas em USD ou EUR e receba em BRL com câmbio e liquidação no mesmo fluxo — sem intermediários.",
        bullets: [
          "Conversão automática na moeda contratada",
          "Comprovante fiscal compatível com exportação",
          "Liquidação em horas, não dias",
        ],
      },
      fintech: {
        label: "Fintech",
        painCta: "Aceita cripto, liquida em fiat",
        headline: "Cobrança cripto sem virar exchange.",
        description:
          "Aceite USDT, USDC ou BTC do seu cliente e liquide automaticamente em BRL ou USD — sem custódia, sem KYC adicional.",
        bullets: [
          "Webhooks HMAC para conciliação em tempo real",
          "Validação cross-rede evita perda de fundos",
          "Compliance herdado, sem cargo extra",
        ],
      },
      plataforma: {
        label: "Plataforma",
        painCta: "Checkout multiativo na LATAM",
        headline: "Qualquer moeda no checkout.",
        description:
          "Plataformas internacionais vendendo na América Latina usam a mesa pra aceitar fiat local, stablecoin e cripto num trilho só.",
        bullets: [
          "Integração API ou painel em menos de um dia",
          "Taxas transparentes por faixa de volume",
          "SDK Node, Python e Go com exemplos reais",
        ],
      },
      global: {
        label: "Empresa Global",
        painCta: "Tesouraria em 3+ moedas",
        headline: "Cobrança e tesouraria multi-moeda.",
        description:
          "Empresas em múltiplos países consolidam cobrança, câmbio e tesouraria num único trilho auditável.",
        bullets: [
          "Conciliação automática por referência única",
          "Relatórios por moeda, entidade e contrato",
          "Ledger auditável, compatível com Big 4",
        ],
      },
    },
  },
  assetsRails: {
    kicker: "Cobertura completa",
    title: "Um trilho. Muitas moedas.",
    description:
      "Começamos com um conjunto curado — fiat, stablecoin e cripto — que cobre a maioria dos corredores de pagamento. Mais em breve, sempre com validação real.",
    linkLabel: "Ver catálogo completo",
    moreInBreve: "+ em breve",
    stats: {
      moedas: "moedas ativas",
      redes: "redes e trilhos",
      classes: "classes de ativo",
    },
    columns: {
      fiat: { label: "Fiat", caption: "Liquidação bancária direta" },
      stablecoins: { label: "Stablecoins", caption: "Multi-rede com validação" },
      crypto: { label: "Criptoativos", caption: "Rails nativos" },
    },
    currencyLabels: {
      USD: "Dólar americano",
      BRL: "Real brasileiro",
      EUR: "Euro",
      MXN: "Peso mexicano",
      USDT: "Tether",
      USDC: "USD Coin",
      DAI: "Dai",
      BTC: "Bitcoin",
      ETH: "Ethereum",
    },
  },
  security: {
    kicker: "Segurança & Compliance",
    title: "Controles institucionais, do primeiro dia.",
    description:
      "Toda transação passa por uma camada de compliance real. Não é marketing — é código, log e política.",
    note:
      "Sem certificações inventadas. Apenas os controles implementados hoje, auditáveis por quem contrata.",
    pillars: {
      kyc: {
        category: "Onboarding",
        title: "KYC / KYB completo",
        description:
          "Validação documental de pessoas e empresas antes do primeiro trade. Checagem de sanções e PEP.",
      },
      aml: {
        category: "Transacional",
        title: "Monitoramento AML",
        description:
          "Regras e tipologias aplicadas em tempo real. Flags revisadas por analistas humanos.",
      },
      custody: {
        category: "Custódia",
        title: "Custódia segregada",
        description:
          "Fundos de clientes mantidos separados do balanço operacional. Sem cofre único, sem risco cruzado.",
      },
      ledger: {
        category: "Auditoria",
        title: "Ledger auditável",
        description:
          "Toda movimentação registrada com hash encadeado. Exportável em CSV ou via API para seu time contábil.",
      },
      regulatory: {
        category: "Regulatório",
        title: "Conformidade regulatória",
        description:
          "Operação alinhada com BACEN e COAF no Brasil. Políticas documentadas e revisadas trimestralmente.",
      },
      environments: {
        category: "Infraestrutura",
        title: "Segregação de ambientes",
        description:
          "Produção, staging e sandbox isolados por rede e credencial. Chaves efêmeras em cada deploy.",
      },
    },
  },
  api: {
    kicker: "/ 04 · Para desenvolvedores",
    rail: "API",
    statusLabel: "API operational",
    title: "Tudo o que a mesa faz, você faz pela API.",
    description:
      "REST versionada, Webhooks assinados com HMAC-SHA256, sandbox idêntico à produção. Primeira chamada em minutos, não dias.",
    tabs: { request: "Request", response: "Response" },
    copyLabel: "Copiar",
    copiedLabel: "Copiado",
    signature: "BUILT FOR DEVELOPERS",
    specSheetLabel: "Especificação técnica",
    stats: {
      uptime: "Uptime SLA",
      latency: "P50 latency",
      regions: "Regiões",
      sdks: "SDKs oficiais",
    },
    spec: {
      protocol: { label: "Protocol", value: "REST · HTTP/1.1, HTTP/2", note: "JSON + UTF-8" },
      auth: { label: "Auth", value: "Bearer token + HMAC-SHA256", note: "Rotação in-place" },
      limits: { label: "Rate limit", value: "1.000 req/min · burst 50", note: "Header ratelimit" },
      versioning: { label: "Versioning", value: "Semver · deprecation 12 meses", note: "Changelog público" },
      sdks: { label: "SDKs", value: "Node · Python · Go · Ruby", note: "Exemplos reais" },
      sandbox: { label: "Sandbox", value: "Espelho completo da produção", note: "Dados fictícios" },
    },
    ctaPrimary: "Ler a documentação",
    ctaSecondary: "Solicitar acesso à API",
  },
  pricing: {
    kicker: "/ 09 · Preços",
    rail: "PRICING",
    tag: "Sob consulta",
    title: "Precificação sob consulta. Sem surpresas, sem cobrança oculta.",
    description:
      "Trabalhamos com modelos por faixa de volume, spread transparente e taxa de liquidação combinada por contrato. Não há setup fee.",
    formulaLabel: "Modelo de preço",
    legend: {
      spread: "Diferença visível entre bid e ask",
      volume: "Faixa mensal combinada por contrato",
      ativo: "Fiat · stablecoin · cripto",
    },
    attributes: {
      setupFee: { label: "Setup fee", value: "Zero", note: "Sem cobrança de entrada" },
      spread: { label: "Spread", value: "Transparente", note: "Exibido em cada cotação" },
      taxa: { label: "Taxa", value: "Por faixa de volume", note: "Negociada por contrato" },
      contrato: { label: "Contrato", value: "Customizável", note: "Termos sob medida" },
    },
    process: {
      label: "Processo",
      "01": { label: "Conversa inicial", detail: "15 minutos sobre o caso" },
      "02": { label: "Estimativa", detail: "Em até 1 dia útil" },
      "03": { label: "Contrato", detail: "Termos por escrito" },
    },
    primaryCta: "Falar com a mesa",
    ctaHelper: "Ninguém vende. Apenas avalia seu caso.",
    note: "Estimativa inicial em até 1 dia útil após breve conversa sobre seu caso.",
    signature: "TRANSPARENT BY DESIGN",
  },
  faq: {
    kicker: "Perguntas frequentes",
    title: "Perguntas que chegam antes do primeiro call.",
    description: "Se ficou alguma pergunta depois disso, fale com a mesa.",
    items: {
      what: {
        question: "O que é a MesaOTC?",
        answer:
          "Infraestrutura de cobrança e liquidação multiativo. Você cobra em uma moeda e recebe em outra — fiat, stablecoin ou cripto — com liquidez própria e operação institucional embutida. Não é exchange, corretora nem carteira.",
      },
      liquidation: {
        question: "Como funciona a liquidação?",
        answer:
          "Seu cliente paga na moeda escolhida e a mesa entrega na moeda que você definiu como receiving. Usamos liquidez própria para fechar o ciclo — sem depender de corretoras externas ou janelas de mercado. Em geral, em minutos após confirmação on-chain ou bancária.",
      },
      assets: {
        question: "Quais moedas e redes vocês suportam?",
        answer:
          "Fiat: BRL (PIX, TED), USD (WIRE, ACH), EUR (SEPA), MXN (SPEI). Stablecoins: USDT (ERC20, TRC20, Polygon), USDC (ERC20, Solana, Base), DAI (ERC20). Cripto: BTC (Mainnet, Lightning), ETH (Mainnet). Ativos adicionais liberados conforme demanda e validação.",
      },
      compliance: {
        question: "Como é feito o compliance?",
        answer:
          "KYC e KYB completo antes do primeiro trade (documentação, sanções, PEP). Monitoramento AML em tempo real com regras e tipologias. Custódia segregada, ledger auditável com hash encadeado, segregação de ambientes (produção/staging/sandbox). Operação alinhada com BACEN e COAF.",
      },
      integration: {
        question: "Quanto tempo leva para integrar?",
        answer:
          "A maioria dos times chega à primeira chamada em sandbox em menos de um dia. A produção depende do KYB e do tipo de integração — painel só exige cadastro; API exige credencial de produção após validação.",
      },
      costs: {
        question: "Quais os custos?",
        answer:
          "Precificação combinada por contrato, com base em faixa de volume, moedas operadas e redes utilizadas. Sem setup fee. Estimativa inicial em até 1 dia útil após breve conversa sobre seu caso.",
      },
      sla: {
        question: "Vocês têm SLA?",
        answer:
          "Sim. SLA de disponibilidade da API, tempo médio de liquidação e canal dedicado de suporte são definidos no contrato, de acordo com o tier de volume. Status público em status.mesaotc.com.",
      },
      "api-access": {
        question: "Como peço acesso à API?",
        answer:
          "Solicite acesso em contato@mesaotc.com ou pelo CTA 'Solicitar acesso à API'. Após validação básica, enviamos credenciais de sandbox imediatamente; credenciais de produção saem após KYB concluído.",
      },
    },
  },
  contact: {
    kicker: "/ 11 · Contato",
    rail: "CONTACT",
    title: "Conte o caso. Voltamos em 1 dia útil.",
    description:
      "Uma conversa de 15 minutos basta pra avaliar se faz sentido pra sua operação. Sem vendedor, sem pitch.",
    reassuranceSpec: {
      response: { label: "Resposta", value: "Em 1 dia útil" },
      assessment: { label: "Avaliação", value: "Gratuita, sem compromisso" },
      privacy: { label: "Sigilo", value: "NDA implícito desde a primeira linha" },
    },
    reassurance: [
      "Resposta em até 1 dia útil",
      "Avaliação gratuita",
      "Sigilo de informações",
    ],
    successTitle: "Recebido.",
    successMessage:
      "Recebemos sua mensagem. Um consultor responde em 1 dia útil no seu e-mail.",
    successHint: "Enquanto isso, você pode",
    successLinkLabel: "ler a documentação",
    submitCta: "Enviar mensagem",
    submitMicrocopy: "Você pode responder esta conversa direto do seu inbox.",
    signature: "STARTS A CONVERSATION",
    altChannels: {
      label: "Canais diretos",
      directLabel: "Direct",
      agendaLabel: "Agendar",
      agendaValue: "cal.com/mesaotc",
    },
    form: {
      sectionLabel: "Formulário",
      nameLabel: "Nome",
      namePlaceholder: "Seu nome completo",
      nameHint: "Como você quer ser chamado",
      companyLabel: "Empresa",
      companyPlaceholder: "Nome da empresa",
      companyHint: "Razão social ou fantasia",
      emailLabel: "E-mail corporativo",
      emailPlaceholder: "voce@empresa.com",
      emailHint: "Use um e-mail corporativo",
      volumeLabel: "Volume estimado / mês",
      volumePlaceholder: "Selecione uma faixa",
      volumeHint: "Faixa mensal aproximada",
      volumeOptions: {
        "ate-30k": "Até USD 30 mil",
        "30k-100k": "USD 30 mil – 100 mil",
        "100k-500k": "USD 100 mil – 500 mil",
        "500k-1m": "USD 500 mil – 1 milhão",
        "1m-5m": "USD 1 milhão – 5 milhões",
        "5m+": "Acima de USD 5 milhões",
        avaliando: "Ainda avaliando",
      },
      messageLabel: "Mensagem",
      messagePlaceholder:
        "Conte brevemente sobre sua operação — moedas envolvidas, frequência, objetivo.",
      messageHint: "Até 1000 caracteres",
      validation: {
        nameRequired: "Informe seu nome.",
        companyRequired: "Informe o nome da empresa.",
        emailRequired: "Informe seu e-mail corporativo.",
        emailInvalid: "E-mail inválido.",
        emailPersonal: "Use um e-mail corporativo.",
        volumeRequired: "Selecione uma faixa de volume.",
        messageRequired: "Conte brevemente sobre sua operação.",
      },
    },
  },
  finalCta: {
    title: "Pronto para operar em qualquer moeda?",
    description:
      "Conecte a mesa ao seu fluxo de cobrança e liquidação em uma conversa.",
    primaryCta: "Falar com a mesa",
    secondaryCta: "Ler a documentação",
  },
  footer: {
    tagline: "Infraestrutura de cobrança e liquidação multiativo.",
    columns: {
      product: {
        label: "Produto",
        links: {
          howItWorks: "Como funciona",
          useCases: "Casos de uso",
          assets: "Ativos & trilhos",
          security: "Segurança",
          pricing: "Preços",
        },
      },
      developer: {
        label: "Desenvolvedor",
        links: {
          docs: "Documentação",
          apiReference: "Referência de API",
          status: "Status",
          changelog: "Changelog",
        },
      },
      company: {
        label: "Empresa",
        links: {
          useCases: "Casos de uso",
          contact: "Contato",
          faq: "FAQ",
        },
      },
      legal: {
        label: "Legal",
        links: {
          privacy: "Privacidade",
          terms: "Termos",
          compliance: "Compliance",
        },
      },
    },
    meta: {
      address: "São Paulo, Brasil",
      legalName: "MesaOTC Tecnologia Ltda.",
      statusLabel: "Operação estável",
      region: "BRASIL · LATAM",
      rights: "Todos os direitos reservados.",
    },
    languageLabel: "Idioma",
  },
  theme: {
    toLight: "Ativar tema claro",
    toDark: "Ativar tema escuro",
  },
} as const
